import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import ShareableLinkLockScreen from '../ShareableLinkLockScreen';
import EmptyState from 'assets/images/reports-empty-state.webp';
import { BUSINESS_ROUTE } from 'data/global';
import { Link } from 'react-router-dom';

import './ShareableLinkNotFound.styles.scss';

type ShareableLinkNotFoundProps = {
  className?: string;
};

const ShareableLinkNotFound: React.FC<ShareableLinkNotFoundProps> = (props) => {
  const { className } = props;

  const classes = classNames('shareable-link-not-found', className);

  const { t } = useTranslation();

  return (
    <ShareableLinkLockScreen
      title={t('shareableLinkNotFound')}
      className={classes}
      image={EmptyState}
    >
      <Link
        to={BUSINESS_ROUTE}
        className="ncoded-button ncoded-button--outline"
      >
        {t('visitOurPublicMarketplaceUC')}
      </Link>
    </ShareableLinkLockScreen>
  );
};

export default ShareableLinkNotFound;
